import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type RampPurchaseOrderCopyFieldsFragment = { __typename?: 'RampPurchaseOrderCopyData', purchaseOrderId: string, operation: Types.RampPurchaseOrderCopyOperation, status: Types.RampPurchaseOrderCopyStatus, notCopiedReason?: Types.RampPurchaseOrderNotCopiedReason | null, rampPurchaseOrderNumber?: string | null, rampPurchaseOrderUrl?: string | null, retryCount: number, errorMessage?: string | null, completedAt?: Types.TDateISO | null };

export type GetRampPurchaseOrderCopyQueryVariables = Types.Exact<{
  purchaseOrderId: Types.Scalars['String']['input'];
}>;


export type GetRampPurchaseOrderCopyQuery = { __typename?: 'Query', rampPurchaseOrderCopy?: { __typename?: 'RampPurchaseOrderCopyData', purchaseOrderId: string, operation: Types.RampPurchaseOrderCopyOperation, status: Types.RampPurchaseOrderCopyStatus, notCopiedReason?: Types.RampPurchaseOrderNotCopiedReason | null, rampPurchaseOrderNumber?: string | null, rampPurchaseOrderUrl?: string | null, retryCount: number, errorMessage?: string | null, completedAt?: Types.TDateISO | null } | null };

export const RampPurchaseOrderCopyFieldsFragmentDoc = new TypedDocumentString(`
    fragment RampPurchaseOrderCopyFields on RampPurchaseOrderCopyData {
  purchaseOrderId
  operation
  status
  notCopiedReason
  rampPurchaseOrderNumber
  rampPurchaseOrderUrl
  retryCount
  errorMessage
  completedAt
}
    `, {"fragmentName":"RampPurchaseOrderCopyFields"});
export const GetRampPurchaseOrderCopyDocument = new TypedDocumentString(`
    query GetRampPurchaseOrderCopy($purchaseOrderId: String!) {
  rampPurchaseOrderCopy(purchaseOrderId: $purchaseOrderId) {
    ...RampPurchaseOrderCopyFields
  }
}
    fragment RampPurchaseOrderCopyFields on RampPurchaseOrderCopyData {
  purchaseOrderId
  operation
  status
  notCopiedReason
  rampPurchaseOrderNumber
  rampPurchaseOrderUrl
  retryCount
  errorMessage
  completedAt
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetRampPurchaseOrderCopy: build.query<GetRampPurchaseOrderCopyQuery, GetRampPurchaseOrderCopyQueryVariables>({
      query: (variables) => ({ document: GetRampPurchaseOrderCopyDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetRampPurchaseOrderCopyQuery, useLazyGetRampPurchaseOrderCopyQuery } = injectedRtkApi;
